import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';
import { extendedTypographyOptions } from '../Typography/Typography.theme.js';

const dataGridProTheme = createTheme(shippoTheme, {
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    color: colors.secondary,
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: colors.secondaryHover,
                        borderBottomColor: colors.borders,
                        borderTop: 'none',
                        textTransform: 'uppercase',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': Object.assign({}, extendedTypographyOptions.caption),
                    '& .MuiDataGrid-columnSeparator': {
                        visibility: 'hidden',
                    },
                    '& .MuiDataGrid-columnHeader:focus-within,& .MuiDataGrid-cell:focus-within,& .MuiDataGrid-cellCheckbox:focus-within': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: colors.accent.background.success,
                        borderColor: colors.borders,
                    },
                    '& .MuiDataGrid-row.Mui-selected': {
                        backgroundColor: colors.backgroundDeemphasized,
                    },
                    '& .MuiDataGrid-cell': {
                        borderColor: colors.borders,
                    },
                    '& .MuiDataGrid-cell:focus': {
                        backgroundColor: colors.backgroundDeemphasized,
                    },
                    '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell:focus': {
                        backgroundColor: colors.borders,
                    },
                    '& .MuiCheckbox-colorPrimary.Mui-checked': {
                        color: colors.accent.foreground.success,
                    },
                    '& .MuiCheckbox-colorPrimary:not(.Mui-checked)': {
                        color: colors.secondary,
                    },
                    '& .MuiCheckbox-colorPrimary.Mui-disabled': {
                        color: colors.secondaryDisabled,
                    },
                    '& .MuiDataGrid-footerContainer': {
                        borderTop: `1px solid ${colors.borders}`,
                    },
                },
            },
        },
    },
});

export { dataGridProTheme as default };
//# sourceMappingURL=DataGridPro.theme.js.map
